import * as React from 'react';
import { ConfirmationDialog } from '@/components/ui/confirmation-dialog';
import { Text } from '@/components/ui/text';
import { Compass } from 'lucide-react-native';
import { View } from 'react-native';
import type { EligibleTour } from '../types';

interface ContextualTourPromptProps {
  visible: boolean;
  tour: EligibleTour | null;
  onAccept: () => void;
  onDecline: () => void;
}

function ContextualTourPrompt({
  visible,
  tour,
  onAccept,
  onDecline,
}: ContextualTourPromptProps) {
  if (!tour) {
    return null;
  }

  return (
    <ConfirmationDialog
      visible={visible}
      onClose={onDecline}
      variant="default"
      icon={Compass}
      title="Quick Tour Available"
      description="Want a quick tour of this feature?"
      actions={[{ label: 'Show me', variant: 'primary', onPress: onAccept }]}
      cancelLabel="No thanks"
      testID="contextual-tour-prompt"
    >
      <View style={{ marginTop: 4 }}>
        <Text className="text-muted-foreground text-sm">{tour.title}</Text>
      </View>
    </ConfirmationDialog>
  );
}

export { ContextualTourPrompt };
export type { ContextualTourPromptProps };
